module.exports = __webpack_public_path__ + "static/media/cscu_badge.6c38a393.png";